export default {
  copy: 'copy'
};
